import React, { useMemo } from "react";
import "../../../index.css";
import { pivotiseData } from "../Utils/DataTransform/transformData2";
import {
  getSheetControls,
  setSheetControls,
} from "../../../features/reduxworkbook/WorkbookControllingSlice";
import { useDispatch, useSelector } from "react-redux";
import { sortData } from "../Utils/SortData";
import {
  getL1SheetProperty,
  getL2SheetProperty,
  getWorkbookProperty,
} from "../../../features/reduxworkbook/WorkbookSlice";
import DynamicTable from "../Utils/DynamicTable";
import { dispatchSortValues } from "../Utils/ChartsFunctions";

import { checkExternalTotalRequired } from "../Utils/DataTransform/checkExternalTotals";
import { useFetchTotalsFromApi } from "../Utils/DataTransform/getTotalsFromApi";
import { updateTableHeaderWithHirarchyKeys } from "../Utils/updateTableHeaderWithHirarchyKeys";
import LoadingIndicator from "../../BasicComponents/LoadingIndicator";
import { useState } from "react";
import { MdNavigateNext } from "react-icons/md";
import { MdNavigateBefore } from "react-icons/md";
const PiviotTable = (props) => {
  const {
    Data,
    rowKeys: rawRowKeys,
    groupByKeys: rawGroupByKeys,
    valueKeys,
    Sheetid,
    sortProperties,
    dataSourceID,
    filters,
    commonFilters,
    vizType,
  } = props;
  console.log(vizType);

  const groupByKeys = rawGroupByKeys.map((item) => item.responseKey);
  const dispatch = useDispatch();
  const SufixPrefix = valueKeys.map((item) => {
    return {
      key: item.responseKey,
      numberObject: item.numberFormat, // Use square brackets for dynamic keys
    };
  });
  const rowsPerPage = 25;
  const [currentPage, setCurrentPage] = useState(1);

  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );
  const quickTableArray = useSelector((state) => {
    return getL2SheetProperty(state, Sheetid, "actions", "quickTable");
  });
  const hierarchy =
    useSelector((state) => getWorkbookProperty(state, "hierarchy")) || [];
  const {
    isRowTotalVisible,
    isColumnTotalVisible,
    isMeasureOnTop,
    conditionalFormatting,
    isCustomAlign,
    rowAlign,
    valueAlign,
  } = customizationObject;

  const externalTotalResult = useMemo(() => {
    return checkExternalTotalRequired({
      valueKeys,
      quickTableArray,
      sortProperties,
      isRowTotalVisible,
      isColumnTotalVisible,
      Data,
      dataSourceID,
      rawRowKeys,
      rawGroupByKeys,
      Sheetid,
      filters,
      commonFilters,
    });
  }, [
    valueKeys,
    quickTableArray,
    sortProperties,
    isRowTotalVisible,
    isColumnTotalVisible,
    Data,
    dataSourceID,
    rawRowKeys,
    rawGroupByKeys,
  ]);
  console.log(isMeasureOnTop);
  const {
    grandTotalRequired,
    columnTotalRequired,
    rowTotalRequired,
    rowTotalQuery,
    columnTotalQuery,
    grandTotalQuery,
  } = externalTotalResult;

  console.log(columnTotalRequired, grandTotalRequired);

  // Fetch total data from API
  const {
    data: totalData,
    isLoading = true,
    isSuccess,
    isError,
    error,
  } = useFetchTotalsFromApi({
    grandTotalRequired,
    columnTotalRequired,
    rowTotalRequired,
    rowTotalQuery,
    columnTotalQuery,
    grandTotalQuery,
    Sheetid,
  });

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (isError) {
    console.log(error);
    return <p>Error while fetching totals : {error?.data?.error}</p>;
  }

  console.log(isLoading, isSuccess, isError, error);
  if (isSuccess) {
    const {
      uniqueTableRows,
      measureAttachedColumnValueKeys,
      totalRowForColumnTotals,
      destructuredHeader,
      headerKeySequence,
      rowTotalColumnKeys,
      maxMinData,
    } = pivotiseData({
      rawData: Data,
      rawGroupByKeys: rawGroupByKeys,
      rawRowKeys: rawRowKeys,
      valueObjectArray: valueKeys,
      isRowTotalVisible: isRowTotalVisible,
      isColumnTotalVisible: isColumnTotalVisible,
      isMeasureOnTop: isMeasureOnTop !== undefined ? isMeasureOnTop : false,
      totalData: totalData,
      grandTotalRequired: grandTotalRequired,
      columnTotalRequired: columnTotalRequired,
      rowTotalRequired: rowTotalRequired,
      quickTableArray: quickTableArray,
    });
    // console.log(isLoading, isSuccess, isError, error);
    console.log(valueKeys);
    console.log(destructuredHeader);

    const newArray =
      measureAttachedColumnValueKeys.length > 0 && valueKeys.length > 0
        ? [
            ...measureAttachedColumnValueKeys,
            ...valueKeys.map((obj) => `Total ${obj.responseKey}`),
          ]
        : [];

    if (groupByKeys.length > 0) {
      dispatchSortValues({ newArray, dispatch, setSheetControls, Sheetid });
    }

    console.log(uniqueTableRows);
    const data =
      sortProperties.length > 0 && rawGroupByKeys.length > 0
        ? sortData({
            transformedData: uniqueTableRows,
            sortProperties,
            rawRowKeys,
            rawGroupByKeys,
            requiredArray: rawRowKeys,
          })
        : uniqueTableRows;

    isColumnTotalVisible && data.push(totalRowForColumnTotals);

    console.log(rawGroupByKeys.length > 0 && sortProperties.length > 0);
    const headerHierarchyKeys = [];
    rawGroupByKeys.forEach((element) => {
      let hierarchyKey = null;
      if (element.dataType === "String") {
        hierarchyKey = element.rename;
      }
      if (element.dataType === "Date") {
        hierarchyKey = `${element.rename}${element.dateFormat.value}`;
      }
      headerHierarchyKeys.push(hierarchyKey);
    });
    rawRowKeys.forEach((element) => {
      let hierarchyKey = null;
      if (element.dataType === "String") {
        hierarchyKey = element.rename;
      }
      if (element.dataType === "Date") {
        hierarchyKey = `${element.rename}${element.dateFormat.value}`;
      }
      headerHierarchyKeys.push(hierarchyKey);
    });
    // console.log(headerHierarchyKeys);

    const mappedHierarchy = headerHierarchyKeys.reduce((acc, hItemKey) => {
      const matchingItem = hierarchy.find((hItem) =>
        hItem.hierarchyArray.some((hItemHItem) => {
          if (hItemHItem.dataType === "String") {
            return hItemHItem.rename === hItemKey;
          } else if (hItemHItem.dataType === "Date") {
            return (
              `${hItemHItem.rename}${hItemHItem.dateFormat.value}` === hItemKey
            );
          }
        })
      );

      if (matchingItem) {
        acc[hItemKey] = matchingItem; // Map headerHierarchy key to the matching item
      }

      return acc;
    }, {});

    console.log(destructuredHeader);

    // console.log(mappedHierarchy);
    const transformedTableHeader = updateTableHeaderWithHirarchyKeys({
      destructuredHeader,
      rawRowKeys,
      rawGroupByKeys,
      isMeasureOnTop: isMeasureOnTop !== undefined ? isMeasureOnTop : false,
      headerHierarchyKeys,
      mappedHierarchy,
      isColumnTotalVisible,
      vizType
    });
    // console.log(transformedTableHeader);
    const totalPages = Math.ceil(data.length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const paginatedData = data.slice(startIndex, startIndex + rowsPerPage);

    console.log(uniqueTableRows);
    // console.log(transformedTableHeader);
    // console.log(Sheetid);

    return (
      <>
        <DynamicTable
          tableHeader={transformedTableHeader}
          tableData={data.length > 100 ? paginatedData : data}
          headerKeys={headerKeySequence}
          quickTable={quickTableArray.length > 0 && quickTableArray}
          measureAttachedColumnValueKeys={measureAttachedColumnValueKeys}
          SufixPrefix={SufixPrefix}
          Sheetid={Sheetid}
          rowKeys={rawRowKeys}
          valueKeys={valueKeys}
          isMeasureOnTop={isMeasureOnTop !== undefined ? isMeasureOnTop : false}
          rowTotalColumnKeys={rowTotalColumnKeys}
          isColumnPresent={rawGroupByKeys.length > 0}
          groupByKeys={rawGroupByKeys}
          conditionalFormatting={conditionalFormatting}
          maxMinData={maxMinData}
          hierarchy={hierarchy}
          isRowTotalVisible={isRowTotalVisible}
          isColumnTotalVisible={isColumnTotalVisible}
          isCustomAlign={isCustomAlign}
          rowAlign={rowAlign}
          valueAlign={valueAlign}
          columnTotal={totalRowForColumnTotals}
          grandTotalAccordingToKey={totalData.columnTotals}
          vizType={vizType}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
        />
        {/* Pagination Controls */}
        {data.length > 100 && (
          <div className="flex justify-end items-center w-full ">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className={`px-2 gap-x-1 py-[1.7px] border ${
                currentPage === 1
                  ? "bg-gray-200 text-black"
                  : "bg-blue-950 text-white"
              } rounded disabled:opacity-75 tracking-wide flex items-center justify-center`}
            >
              <MdNavigateBefore /> Prev
            </button>

            <span className="px-4">
              {currentPage} / {totalPages}
            </span>

            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              className={`px-2 gap-x-1 py-[1.7px] border ${
                currentPage === totalPages
                  ? "bg-gray-200 text-black"
                  : "bg-blue-950 text-white"
              } rounded disabled:opacity-75 tracking-wide flex items-center justify-center`}
            >
              Next <MdNavigateNext />
            </button>
          </div>
        )}
      </>
    );
  }
};

export default PiviotTable;
